import { createApolloClient } from 'hubspot-apollo-client';
export const client = createApolloClient();